import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { TestRoutineAdd } from '#app/routes/mocra+/_form+/components/test-routines/add.tsx'
import { TestRoutineCard } from '#app/routes/mocra+/_form+/components/test-routines/card.tsx'
import { type TestRoutineDraft } from '#app/routes/mocra+/_form+/components/test-routines/types.ts'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type RoutineListItem = {
	readonly draft: TestRoutineDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly routines: ReadonlyArray<RoutineListItem>
	readonly onAdd: (draft: TestRoutineDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
	readonly emptyState?: string
}

export function RoutineTestingSection({
	resources,
	routines,
	onAdd,
	onEdit,
	onRemove,
	emptyState = 'No routine tests recorded yet.',
}: Props) {
	return (
		<Section
			title="Routine testing"
			description="Capture the recurring tests or checks you run to maintain safety substantiation."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{routines.length > 0 ? (
					routines.map((routine, index) => {
						const errors = routine.errors
						return (
							<TestRoutineCard
								key={`routine-${index}`}
								index={index}
								routine={routine.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">{emptyState}</p>
				)}
			</div>
			<TestRoutineAdd onSubmit={onAdd} />
		</Section>
	)
}
